export default __webpack_public_path__ + "static/media/Diamond_3_Rank.f0613e96.png";